import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/estimate/img/main_visual.png",
  alt: "3月末までがおトク！ 自動車税は4月1日現在の所有者に請求されるので 廃車、買取してもらいたいお車があったら、3月末までに名義変更をおすすめします！！",
  class: "full-width"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { ref, onBeforeUnmount } from 'vue'

// const displayedImage = ref(0)

// const timer = setInterval(() => {
//   displayedImage.value++
//   if (displayedImage.value > 1) {
//     displayedImage.value = 0
//   }
// }, 6000)

// onBeforeUnmount(() => {
//   clearInterval(timer)
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.container)
    }, _hoisted_2, 2)
  ], 2))
}
}

})